import { Button } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import Day from "./Day";

export default function Calendar({ onTaskClicked, windowSize }) {
  const offset = moment().day() + 7 * Math.floor(moment().date() / 7);
  const [monthOffset, setMonthOffset] = useState(0);
  const dayLabels = () => {
    return (
      <div style={{ display: "flex", height: "30px" }}>
        {["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"].map((d) => (
          <div
            style={{
              width: `${100 / 7}%`,
              textAlign: "center",
              fontSize: "25px",
              fontWeight: "300",
            }}
          >
            {d}
          </div>
        ))}
      </div>
    );
  };
  const week = (w) => {
    const startOfMonth = moment().add(monthOffset, "months").startOf("month");
    const startOffset = startOfMonth.day();
    return (
      <div
        style={{
          display: "flex",
          height: `${100 / 6}%`,
          minHeight: `${100 / 6}%`,
        }}
      >
        {[...new Array(7)].map((a, i) => (
          <Day
            windowSize={windowSize}
            monthOffset={monthOffset}
            date={moment(startOfMonth)
              .add(w * 7 + i - startOffset, "days")
              .toISOString()}
            onTaskClicked={onTaskClicked}
          />
        ))}
      </div>
    );
  };
  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "30px",
          // flex: "0 1 30px",
        }}
      >
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            width: "200px",
            display: "flex",
          }}
        >
          <Button onClick={() => setMonthOffset((m) => m - 1)}>{"<"}</Button>
          <div
            style={{ width: "150px", textAlign: "center", paddingTop: "5px" }}
          >
            {moment().add(monthOffset, "months").format("MMMM")}
          </div>
          <Button onClick={() => setMonthOffset((m) => m + 1)}>{">"}</Button>
        </div>
      </div>
      {dayLabels()}
      <div
        style={{
          flexGrow: 1,
          width: "100%",
        }}
      >
        {[...new Array(6)].map((a, i) => week(i))}
      </div>
    </div>
  );
}
